import { InjectionToken } from '@angular/core';

export const WindowInjection = new InjectionToken('window.injection');
